module.exports = __webpack_public_path__ + "img/favicons/ape/android-chrome-512x512.png";